import { getBranchId, getHospitalId } from "../../../auth"
import FetchData from "../../client"

export const GetReferHospitals = async (inputData) => {
    try {
        inputData.branchid = getBranchId();
        inputData.hospitalid = getHospitalId()
        const result = await FetchData("midoc_getreferredhospital", inputData)
        return result
    } catch (error) {
        console.log('Error in fetching refer hospitals data')
        throw error;
    }
}
export const AddReferHospitals = async (inputData) => {
    try {
        inputData.branchid = getBranchId();
        inputData.hospitalid = getHospitalId()
        const result = await FetchData("midoc_addreferredhospital", inputData)
        return result
    } catch (error) {
        console.log('Error in fetching refer hospitals data')
        throw error;
    }
}

export const UpdateReferHospitals = async (inputData) => {
    try {
        inputData.branchid = getBranchId();
        inputData.hospitalid = getHospitalId()
        const result = await FetchData("midoc_updatereferredhospital", inputData)
        return result
    } catch (error) {
        console.log('Error in fetching refer hospitals data')
        throw error;
    }
}

export const DeleteReferHospitals = async (inputData) => {
    try {
        inputData.branchid = getBranchId();
        inputData.hospitalid = getHospitalId()
        const result = await FetchData("midoc_deletereferredhospital", inputData)
        return result
    } catch (error) {
        console.log('Error in fetching refer hospitals data')
        throw error;
    }
}